function preprocess(audioBuffer) {
    /**
       * Preprocess the audio data to  be able to use it for Essentia models
       * @param {Float32Array} audioBuffer - The input audio data.
       * @returns {Float32Array} A new Float32Array containing the audio with ne channel.
   */
    if (audioBuffer instanceof AudioBuffer) {
        const mono = monomix(audioBuffer);
        return downsampleArray(mono, audioBuffer.sampleRate, 16000);
    } else {
        throw new TypeError("Input to audio preprocessing is not of type AudioBuffer");
    }
}

function monomix(buffer) {
    /**
    * Reduces the channels of audio data to one (mono)
    * @param {Float32Array} audioIn - The input audio data.
    * @returns {Float32Array} A new Float32Array containing the audio with one channel.
    */
    let monoAudio;
    if (buffer.numberOfChannels > 1) {
        const leftCh = buffer.getChannelData(0);
        const rightCh = buffer.getChannelData(1);
        monoAudio = leftCh.map((sample, i) => 0.5 * (sample + rightCh[i]));
    } else {
        monoAudio = buffer.getChannelData(0);
    }

    return monoAudio;
}

function downsampleArray(audioIn, sampleRateIn, sampleRateOut) {
    if (sampleRateOut === sampleRateIn) {
        return audioIn;
    }
    let sampleRateRatio = sampleRateIn / sampleRateOut;
    let newLength = Math.round(audioIn.length / sampleRateRatio);
    let result = new Float32Array(newLength);
    let offsetResult = 0;
    let offsetAudioIn = 0;

    while (offsetResult < result.length) {
        let nextOffsetAudioIn = Math.round((offsetResult + 1) * sampleRateRatio);
        let accum = 0,
            count = 0;
        for (let i = offsetAudioIn; i < nextOffsetAudioIn && i < audioIn.length; i++) {
            accum += audioIn[i];
            count++;
        }
        result[offsetResult] = accum / count;
        offsetResult++;
        offsetAudioIn = nextOffsetAudioIn;
    }

    return result;
}


function shortenAudio(audioIn) {
    /**
     * Keeps the 5secs of the audio 
     * @param {Float32Array} audioIn - The input audio data.
     * @returns {Float32Array} A new Float32Array containing the shortened audio.
    */



    const discardSamples = Math.floor(0.1 * audioIn.length); // discard 10% on beginning and end
    audioIn = audioIn.subarray(discardSamples, audioIn.length - discardSamples); // create new view of buffer without beginning and end

    const length = audioIn.length / 16000  // length in secs
    const keepRatio = length < 5 ? 1 : 5 / length;

    const ratioSampleLength = Math.ceil(audioIn.length * keepRatio);
    const patchSampleLength = 187 * 256; // cut into patchSize chunks so there's no weird jumps in audio
    const numPatchesToKeep = Math.ceil(ratioSampleLength / patchSampleLength);

    // space patchesToKeep evenly
    const skipSize = Math.floor((audioIn.length - ratioSampleLength) / (numPatchesToKeep - 1));

    let audioOut = [];
    let startIndex = 0;
    for (let i = 0; i < numPatchesToKeep; i++) {
        let endIndex = startIndex + patchSampleLength;
        let chunk = audioIn.slice(startIndex, endIndex);
        audioOut.push(...chunk);
        startIndex = endIndex + skipSize; // discard even space
    }

    return Float32Array.from(audioOut);
}

export { preprocess, shortenAudio };
